



























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import UrlWrapper from '@/modules/shared/components/shared/UrlWrapper.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import MarkupTableEmptyRow from '@/modules/common/tes-table/components/shared/MarkupTableEmptyRow.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'

@Component({
  components: { DateTooltipped, MarkupTableEmptyRow, SimpleHeader, UrlWrapper, TextEllipsis }
})
export default class ContentLinksTable extends Vue {
  @Prop({ default: () => [] }) dates!: Array<{ key: string, value: string }>
  private persianFields = {
    register_at: 'تاریخ ثبت',
    sent_to_queue_at: 'تاریخ ارسال به نویسنده',
    deliver_at: 'تاریخ تقریبی',
    completed_at: 'تاریخ تکمیل شدن',
    seen_at: 'تاریخ مشاهده'
  }

  get haveDates() {
    return this.dates.length > 0
  }
}
